export enum Roles {
  REGULAR_USER = '',
  ADMINISTRATOR = 'Administrator',
  SUPERADMIN = 'Superadmin',
  PROJECT_MANAGER = 'Project Manager',
  DELIVERY_MANAGER = 'Delivery Manager',
  CSM = 'CSM',
  PROJECT_COORDINATOR = 'Project Coordinator',
  DELIVERY_LEAD = 'Delivery Lead',
}

export const ROLES_ADMINS_AND_MANAGERS = [
  Roles.ADMINISTRATOR,
  Roles.SUPERADMIN,
  Roles.PROJECT_MANAGER,
  Roles.DELIVERY_MANAGER,
  Roles.CSM,
  Roles.PROJECT_COORDINATOR,
  Roles.DELIVERY_LEAD,
];

export const ROLES_ADMINS = [Roles.ADMINISTRATOR, Roles.SUPERADMIN];
